export const COPY_IP_COOLDOWN_MS = 1500;

export async function copyToClipboard(text: string): Promise<void> {
    if (!window.isSecureContext || !navigator.clipboard?.writeText) {
        throw new Error('Clipboard API unavailable');
    }

    await navigator.clipboard.writeText(text);
}
